var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#000",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.66 101.66L139.31 128l26.35 26.34a8 8 0 01-11.32 11.32L128 139.31l-26.34 26.35a8 8 0 01-11.32-11.32L116.69 128l-26.35-26.34a8 8 0 0111.32-11.32L128 116.69l26.34-26.35a8 8 0 0111.32 11.32zM232 128A104 104 0 11128 24a104.11 104.11 0 01104 104zm-16 0a88 88 0 10-88 88 88.1 88.1 0 0088-88z"
  })));
};
export default SvgCrossCircle;